import React from 'react';
import { FormControl, FormHelperText, FormLabel, MenuItem as MuiMenuItem, Select } from '@mui/material';

import type { CustomStep } from '@shared/patient-intake-status';

type DocumentUploadCustomStep = CustomStep['DOCUMENT_UPLOAD'];

interface MenuItemProps extends React.ComponentProps<typeof MuiMenuItem> {
  value: DocumentUploadCustomStep['metadata']['documentType'];
}

const MenuItem: React.FC<MenuItemProps> = ({ value, children, ...props }) => (
  <MuiMenuItem value={value} {...props}>
    {children}
  </MuiMenuItem>
);

const VALUES = {
  IDENTIFICATION: 'Identification',
  MEDICAL_RECORDS: 'Medical Records',
  PRESCRIPTION: 'Prescription',
  OTHER: 'Other',
} satisfies Record<DocumentUploadCustomStep['metadata']['documentType'], string>;

export const DocumentUploadMetadata: React.FC<{
  value: DocumentUploadCustomStep['metadata'];
  onChange: (value: DocumentUploadCustomStep['metadata']) => void;
  error?: string;
}> = ({ value, onChange, error }) => (
  <FormControl fullWidth margin="normal" error={!!error}>
    <FormLabel component="legend">What type of document should the patient upload?</FormLabel>
    <Select value={value.documentType} onChange={(e) => onChange({ ...value, documentType: e.target.value })}>
      {Object.entries(VALUES).map(([value, label]) => (
        <MenuItem key={value} value={value as DocumentUploadCustomStep['metadata']['documentType']}>
          {label}
        </MenuItem>
      ))}
    </Select>
    <FormHelperText>
      This is just a way to tag the uploaded document. Please provide a useful description so the patient knows what to
      upload.
    </FormHelperText>
  </FormControl>
);
